import { render, staticRenderFns } from "./ErrorMaxLeaders.vue?vue&type=template&id=4680043a&"
import script from "./ErrorMaxLeaders.vue?vue&type=script&lang=js&"
export * from "./ErrorMaxLeaders.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports